import { Quote, QuoteDynamicType} from 'acscp/api/models/quote';
import { Authentication } from 'acscp/api/requests/core/baseRequest';
import { BasePostRequest } from 'acscp/api/requests/core/basePostRequest';

export class QuoteAcceptRequest extends BasePostRequest<Quote> {
    constructor(public quoteId: string, public notes?: string, public department?: string) {
        super(`quotes/accept`, {},
            {
                quoteId,
                notes,
                department
            }, QuoteDynamicType, Authentication.SharingToken);
    }
}
